import moment from "moment";
import React from "react";

// UpcomingEvents Component
const DoubleMeetingEvents = ({ events, selectedDate }) => {
  return (
    <section className="py-4">
      <h2 className="text-base font-semibold leading-6 text-wa-text">
        {selectedDate
          ? `Afspraken op ${moment(selectedDate).locale("nl-be").format("D MMMM YYYY")}`
          : "Komende Afspraken"}
      </h2>
      <ol className="mt-2 divide-y divide-wa-border text-sm leading-6 text-wa-muted">
        {events?.length === 0 ? (
          <li className="py-4 sm:flex">
            <p className="mt-2 flex-auto text-wa-muted sm:mt-0">
              {selectedDate
                ? "Geen geplande afspraken op deze datum"
                : "Geen geplande afspraken"}
            </p>
          </li>
        ) : (
          events.map((event, index) => (
            <li key={event?.uri || event?.id || index} className="py-4 sm:flex">
              <p className="mt-2 flex flex-auto items-center gap-x-2 text-wa-text sm:mt-0">
{/*                 <RP_Avatar avatar={event?.user_avatar} size={12} alt={` ${event.user}`} />
 */}                <div>
                  <div>
                    <span className="mr-2 text-md text-wa-text">
                      {event?.invitees?.[0]?.name || "Onbekende patiënt"}
                    </span>
                    <span className="font-semibold text-wa-accent">
                  {" "}
                   - {event.name}
                </span>
                  </div>
                  <time
                    dateTime={event.start_time}
                    className="mr-8 w-40 flex-none text-md text-wa-muted"
                  >
                    {moment(event.start_time)
                      .locale("nl-be")
                      .format("dd, D MMMM YYYY")}
                  </time>
                </div>

               
              </p>
              {event.start_time && event.end_time && (
                <p className="flex-none text-wa-text sm:ml-6">
                  <time dateTime={event.start_time}>
                    {moment(event.start_time).format("HH:mm")}
                  </time>{" "}
                  -{" "}
                  <time dateTime={event.end_time}>
                    {moment(event.end_time).format("HH:mm")}
                  </time>
                </p>
              )}
            </li>
          ))
        )}
      </ol>
    </section>
  );
};

export default DoubleMeetingEvents;
